import React, { useMemo } from 'react';
import MaterialTable from '@material-table/core';

import { TABLE_OPTIONS } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import tableColumns from './tableColumns';

export function CellNumbersTable({ data }) {
  const { localization } = useTableLocalization();

  const tableDefaultColumns = useMemo(() => {
    return tableColumns();
  }, []);

  const options = {
    ...TABLE_OPTIONS.HISTORY
  };

  return (
    <MaterialTable
      columns={tableDefaultColumns}
      data={data.cell_numbers}
      options={options}
      localization={localization}
    />
  );
}

export default CellNumbersTable;
